export const GAME = {
  width: 288,
  height: 512,
  birdX: 70,
  birdRadius: 12,
  gravity: 0.45,
  flapVelocity: -7.4,
  maxFall: 11,
  pipeWidth: 58,
  pipeGap: 148,
  pipeSpeed: 3,
  pipeSpacing: 260,
  ceiling: 0,
  groundHeight: 80,
} as const;

export type Phase = 'ready' | 'playing' | 'gameover';

export interface Bird {
  y: number;
  vy: number;
  tilt: number;
}

export interface Pipe {
  x: number;
  gapY: number;
  passed: boolean;
}

export interface Coin {
  x: number;
  y: number;
  taken: boolean;
}

export const COIN = {
  radius: 10,
  /** Chance (0–1) that a coin spawns alongside each newly created pipe. */
  spawnChance: 0.65,
} as const;

/** Extra-life economy: the first revival costs baseCost coins, and every
 *  subsequent revival costs costStep more (2 → 5 → 8 → 11 …). */
export const EXTRA_LIFE = {
  baseCost: 2,
  costStep: 3,
  invincibleMs: 3000,
} as const;

export default {};